import * as React from 'react';

function RateDefined(props) {
  return (
    <svg width={40} height={56} fill="none" {...props}>
      <rect
        width={40}
        height={56}
        rx={4}
        fill="url(#prefix__paint0_linear_1008_1347)"
      />
      <path
        opacity={0.5}
        d="M7 46h26"
        stroke="#B89EFF"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={8}
        y={4}
        width={24}
        height={24}
      >
        <path fill="#3E0C9D" d="M8 4h24v24H8z" />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          d="M23.313 23.5c-2.095 0-3.87-.727-5.323-2.18-1.454-1.455-2.181-3.23-2.181-5.324 0-2.08.727-3.849 2.18-5.308C19.444 9.23 21.218 8.5 23.313 8.5c2.079 0 3.848.73 5.307 2.188 1.46 1.46 2.189 3.229 2.189 5.308 0 2.095-.73 3.87-2.189 5.323-1.459 1.454-3.228 2.181-5.307 2.181zm.746-7.794v-2.802a.725.725 0 00-.216-.534.726.726 0 00-.535-.216.725.725 0 00-.534.216.726.726 0 00-.215.534v3.054a.84.84 0 00.073.342c.048.11.115.208.2.293l2.32 2.33a.71.71 0 00.53.233.74.74 0 00.54-.233.735.735 0 00.233-.534.735.735 0 00-.233-.535l-2.163-2.148zM11.75 12.75a.726.726 0 01-.534-.216A.726.726 0 0111 12c0-.213.072-.391.216-.535a.726.726 0 01.534-.215h2.308c.212 0 .39.072.534.216a.726.726 0 01.216.534c0 .213-.072.391-.216.535a.726.726 0 01-.534.215H11.75zm-1 4a.726.726 0 01-.534-.216A.727.727 0 0110 16c0-.213.072-.391.216-.535a.726.726 0 01.534-.215h3.308c.212 0 .39.072.534.216a.726.726 0 01.216.534c0 .213-.072.391-.216.535a.726.726 0 01-.534.215H10.75zm1 4a.726.726 0 01-.534-.216A.727.727 0 0111 20c0-.213.072-.391.216-.535a.726.726 0 01.534-.215h2.308c.212 0 .39.072.534.216a.726.726 0 01.216.534c0 .213-.072.391-.216.535a.726.726 0 01-.534.215H11.75z"
          fill="#3E0C9D"
        />
      </g>
      <path
        opacity={0.5}
        d="M7 34h26M7 40h26"
        stroke="#B89EFF"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_1008_1347"
          x1={20}
          y1={0}
          x2={20}
          y2={56}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F3F0FF" />
          <stop offset={1} stopColor="#E4DEFC" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const MemoRateDefined = React.memo(RateDefined);
export default MemoRateDefined;
